<template>
  <CredentialAuthenticator v-slot="{ authenticated, user }">
    <div>
      <div v-if="authenticated && user">
        <ApplicationShell :title="title" :user="user">
          <RouterView :user="user" />
          <EnvironmentBanner class="fixed bottom-0" v-if="notProduction" />
        </ApplicationShell>
      </div>

      <div v-else>
        <EnvironmentBanner class="top-0" v-if="notProduction" />
        <CredentialLoginForm :title="title" />
      </div>

      <ToastNotificationContainer />
    </div>
  </CredentialAuthenticator>
</template>

<script>
import ApplicationShell from '@/components/shell/ApplicationShell'
import CredentialAuthenticator from '@/components/CredentialAuthenticator'
import CredentialLoginForm from '@/components/CredentialLoginForm'
import EnvironmentBanner from '@/components/EnvironmentBanner'

export default {
  components: {
    ApplicationShell,
    CredentialAuthenticator,
    CredentialLoginForm,
    EnvironmentBanner,
  },

  computed: {
    title() {
      return this.$route.meta.title
    },

    notProduction() {
      return process.env.VUE_APP_ENV !== 'production'
    },
  },
}
</script>
